import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NotificationsService } from '@app/_shared/service/http/notifications.service';
import { catchError, filter, interval, map, of, startWith, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsPollService {
  private notificationsService = inject(NotificationsService);
  private readonly destroyRef = inject(DestroyRef);

  readonly notifications = toSignal(
    interval(60000).pipe(
      startWith([]),
      filter(() => !document.hidden),
      switchMap(() => this.notificationsService.index().pipe(catchError(() => of({ data: [] })))),
      map((response) => response.data),
      takeUntilDestroyed(this.destroyRef),
    ),
    { initialValue: [] },
  );
}
